import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  initiateNewTransaction,
  resetPaymentMethod,
  selectPaymentMethod,
  selectProcessingResultAction,
  selectRegistrationResultAction,
} from '@cashier/cashier-data-access';
import {
  PaymentMethodInput,
  ResultActionTypes,
  ResultTypes,
} from '@cashier/cashier-model';

interface UsePaymentResult {
  resultType: ResultTypes;
  informationFields: PaymentMethodInput[];
  paymentMethodMessage: string | null;
  onButtonClick: () => void;
}

export const usePaymentResult = (): UsePaymentResult => {
  const processingResultAction = useSelector(selectProcessingResultAction);
  const registrationResultAction = useSelector(selectRegistrationResultAction);
  const paymentMethod = useSelector(selectPaymentMethod);

  const { final_screen_description } = paymentMethod || {};
  const resultAction = registrationResultAction || processingResultAction;

  const dispatch = useDispatch();

  const resultType = useMemo((): ResultTypes => {
    const { type } = resultAction || {};

    return type === ResultActionTypes.DISPLAY
      ? ResultTypes.INFORMATION
      : ResultTypes.STATUS;
  }, [resultAction]);

  const informationFields = useMemo(() => {
    return resultAction?.fields || [];
  }, [resultAction]);

  const onButtonClick = useCallback(() => {
    dispatch(initiateNewTransaction());
    dispatch(resetPaymentMethod());
  }, [dispatch]);

  return {
    resultType,
    paymentMethodMessage: final_screen_description || null,
    informationFields,
    onButtonClick,
  };
};
